import { z } from 'zod';

const emailFormatCheck = z.string().email();

export const unsubscribeSchema = z.object({
  // Mirrors UnsubscribeType's NotBlank + Email(strict) + Length(max:50): Symfony skips format
  // constraints entirely when the value is blank, so a blank email must show ONLY the NotBlank
  // message, not also fail Email/Length simultaneously.
  email: z
    .string()
    .optional()
    .superRefine((val, ctx) => {
      const v = val ?? '';
      if (!v) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Ta wartość nie powinna być pusta.' });
        return;
      }
      if (v.length > 50) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Ta wartość jest za długa. Powinna mieć 50 znaków lub mniej.' });
        return;
      }
      if (!emailFormatCheck.safeParse(v).success) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, message: 'Ta wartość nie jest prawidłowym adresem email.' });
      }
    }),
});

// Not z.infer: the schema's `.optional()` exists only to tolerate a missing key defensively
// (see NOT_BLANK_MESSAGE handling above) — by the time RHF calls onSubmit, validation has
// already guaranteed email is a non-empty string.
export type UnsubscribeFormValues = { email: string };
